import { combineReducers } from "redux";
import authReducer from "./auth";
import userReducer from "./user";
import progressReducer from "./progress";
import produtoReducer from "./produto";
import fotoReducer from "./foto";
import catalogoReducer from "./catalogo";
import analyticsReducer from "./analyticsReducer";
import notificationReducer from "./notification";

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  progress: progressReducer,
  produtos: produtoReducer,
  fotos: fotoReducer,
  catalogo: catalogoReducer,
  analytics: analyticsReducer,
  notification: notificationReducer,
});
